/**
 * How to grant the scan service account read access.
 * Account comes from GIT_SERVICE_USER (sec-scan settings).
 */
import React from 'react';

export const serviceAccountLabel = (serviceUser) => {
  const value = String(serviceUser || '').trim();
  return value || 'the AI Garage service user';
};

export const ServiceAccountAccessSteps = ({ serviceUser }) => {
  const account = serviceAccountLabel(serviceUser);
  const isEmail = account.includes('@');
  return (
    <div className="service-account-access">
      <p className="garage-field-hint" style={{ marginBottom: '0.5rem' }}>
        The scanner reads the repository as this account. Minimum access:
      </p>
      <ul className="sec-scan-access-steps">
        <li>
          <strong>{isEmail ? 'Email' : 'Account'}:</strong> {account}
        </li>
        <li>
          <strong>Role:</strong> Reporter. That is the minimum GitLab project role that can clone.
          Guest is not enough. Developer or higher also works.
        </li>
        <li>
          <strong>Token scope</strong> (only if you paste a token): <code>read_repository</code>.
          A project access token also needs role Reporter.
        </li>
      </ul>
      <p className="garage-field-hint" style={{ margin: '0.75rem 0 0.35rem' }}>
        <strong>Invite the service account</strong>
      </p>
      <ol className="sec-scan-access-steps">
        <li>Open the GitLab project.</li>
        <li>Go to <strong>Manage → Members</strong> (or <strong>Project information → Members</strong>).</li>
        <li>
          Invite {isEmail ? 'email' : 'user'} <strong>{account}</strong>.
        </li>
        <li>Set the role to <strong>Reporter</strong>.</li>
        <li>Save the invite. Leave the token blank so we check as that account.</li>
      </ol>
      <p className="garage-field-hint" style={{ margin: '0.75rem 0 0.35rem' }}>
        <strong>Or paste a token</strong>
      </p>
      <ol className="sec-scan-access-steps">
        <li>
          User token: <strong>Preferences → Access Tokens</strong>. Project token:{' '}
          <strong>Settings → Access Tokens</strong>.
        </li>
        <li>
          Scope: <code>read_repository</code>. Project token role: <strong>Reporter</strong>.
        </li>
        <li>Paste the token below. It is encrypted before upload and is not shown again.</li>
      </ol>
    </div>
  );
};

export default ServiceAccountAccessSteps;
